import { styled } from "@core-ui/react-stitch";

interface StarReviewStyledWrapperProps {
  isProductOutOfStock?: boolean;
}
export const StarReviewStyledWrapper = styled.a<StarReviewStyledWrapperProps>(
  props => ({
    marginTop: "8px",
    marginBottom: "8px",
    display: "inline-block",
    ...(props.isProductOutOfStock
      ? {
          pointerEvents: "none",
        }
      : {}),
  })
);
